if (!customElements.get('product-popup')) {
  class ProductPopup extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector('.header');
      this.isOpen = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.content = this.querySelector('[data-product-popup-content]');
      this.closeButtons = this.querySelectorAll('[data-product-popup-close]');

      this.addEventListener('click', (event) => {
        if (event.target === this) this.close();
      });

      if (this.content) {
        this.content.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      }

      this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.close();
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          if (event.target === this) this.open();
        });

        document.addEventListener('shopify:block:deselect', (event) => {
          if (event.target === this) this.close();
        });
      }

      const showOncePerSession = this.dataset.showOncePerSession === 'true';

      if (this.dataset.openOnLoad === 'true' && (!showOncePerSession || !this.hasBeenSeen())) {
        window.requestAnimationFrame(() => {
          if (showOncePerSession) this.markAsSeen();
          this.open();
        });
      }
    }

    getStorageKey() {
      return 'product-popup:seen';
    }

    hasBeenSeen() {
      if (window.Shopify && Shopify.designMode) return false;

      try {
        return window.sessionStorage.getItem(this.getStorageKey()) === 'true';
      } catch (error) {
        return false;
      }
    }

    markAsSeen() {
      if (window.Shopify && Shopify.designMode) return;

      try {
        window.sessionStorage.setItem(this.getStorageKey(), 'true');
      } catch (error) {
        // Storage can be unavailable in some privacy modes; the popup still works.
      }
    }

    open() {
      if (this.isOpen) return;

      this.previouslyFocused = document.activeElement;
      this.isOpen = true;
      this.style.display = 'flex';
      this.lockBody();

      window.requestAnimationFrame(() => {
        this.classList.add('product-popup--open');
        const focusTarget = this.querySelector('[data-product-popup-close]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.classList.remove('product-popup--open');

      window.setTimeout(() => {
        this.style.display = 'none';
        this.unlockBody();

        if (this.previouslyFocused && document.contains(this.previouslyFocused)) {
          this.previouslyFocused.focus({ preventScroll: true });
        }
      }, 400);
    }

    lockBody() {
      const scrollbarCompensation = this.getScrollbarCompensation();

      if (!document.body.classList.contains('drawer-locked')) {
        const scrollY = window.scrollY || window.pageYOffset;
        document.body.dataset.drawerScrollY = `${scrollY}`;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add('drawer-locked');
      }

      document.body.style.overflow = 'hidden';

      if (scrollbarCompensation) {
        document.body.style.paddingRight = scrollbarCompensation;
        if (this.header) this.header.style.paddingRight = scrollbarCompensation;
      }
    }

    unlockBody() {
      const openOverlay = document.querySelector('.drawer.drawer--opened, .product-popup.product-popup--open');

      if (openOverlay) return;

      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('top');

      if (document.body.classList.contains('drawer-locked')) {
        document.body.classList.remove('drawer-locked');
        const scrollY = parseInt(document.body.dataset.drawerScrollY || '0', 10);
        delete document.body.dataset.drawerScrollY;
        window.scrollTo(0, scrollY);
      }

      if (this.header) this.header.style.removeProperty('padding-right');
    }

    getScrollbarCompensation() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      return scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
    }
  }

  customElements.define('product-popup', ProductPopup);
}
